// extracted by mini-css-extract-plugin
export default {"inputWrapper":"q08Yef3f","input":"usr2hzmO","inputLabel":"xdKGCi3E"};